import React from 'react';
import { Box, Typography } from '@mui/material';

interface InfoRowProps {
  label: string;
  value?: React.ReactNode;
  labelWidth?: number | string;
  colon?: boolean;
}

export const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  labelWidth = 140,
  colon = true,
}) => {
  return (
    <Box
      display='flex'
      alignItems='flex-start'
      mb={1}
      sx={{ wordBreak: 'break-word', minHeight: '24px' }}
    >
      <Typography
        variant='body2'
        fontWeight='bold'
        color='text.primary'
        sx={{ minWidth: labelWidth, width: labelWidth, flexShrink: 0 }}
      >
        {label}
      </Typography>
      {colon && (
        <Typography
          variant='body2'
          fontWeight='bold'
          color='text.primary'
          sx={{ mx: 0.75, flexShrink: 0 }}
        >
          :
        </Typography>
      )}
      <Typography
        variant='body2'
        color='text.secondary'
        sx={{ flexGrow: 1 }}
        component='span'
      >
        {value !== null && value !== undefined && value !== '' ? value : 'N/A'}
      </Typography>
    </Box>
  );
};

export default InfoRow;
